import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div<{ contentWidth: number; spacingLeft: number; isRetailer?: boolean }>`
    display: flex;
    position: fixed;
    bottom: var(--spacing-3);
    left: ${({ contentWidth }) => (contentWidth ? `${contentWidth / 2}px` : "50%")};
    flex-direction: column-reverse; /* New notifications appear at the bottom */
    row-gap: var(--spacing-1);
    transform: translateX(-50%);
    z-index: var(--z-index-fixed);

    @media screen and (min-width: ${breakpoints.max}) {
        left: ${({ contentWidth, spacingLeft }) =>
            contentWidth ? `calc(${spacingLeft}px + ${contentWidth / 2}px)` : "50%"};
    }

    ${({ isRetailer }) =>
        isRetailer &&
        css`
            bottom: var(--spacing-11);
        `}
`;
